module.exports = __webpack_public_path__ + "static/img/icon_spjj.20aed2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/icon_spjj.png
// module id = Oo8i
// module chunks = 1